import { useMutation } from '@tanstack/react-query';
import { useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Card,
    CardContent,
    CardHeader,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import Button from '@mui/material/Button';

import Api from '@barboxx/api';
import { Place } from '@barboxx/models';
import { useBool } from '@barboxx/react-utils';

interface Props {
    place: Place;
}

export const PlaceDeleteCard = ({ place }: Props) => {
    const notifications = useNotifications();
    const navigate = useNavigate();
    const [open, dialogActions] = useBool();

    const mutateDeletePlace = useMutation({
        mutationKey: ['place', place.id],
        mutationFn: () => Api.Places.deletePlace(place.id),
    });

    const onDelete = async () => {
        mutateDeletePlace
            .mutateAsync()
            .then(({ data }) => {
                notifications.show('Deleted place!', {
                    severity: 'success',
                });
                navigate(-1);
            })
            .catch(e => {
                notifications.show(e.message, {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete Place" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this place
                    </Typography>

                    <Button
                        onClick={dialogActions.on}
                        color="error"
                        variant="outlined"
                    >
                        Delete
                    </Button>
                </Stack>
            </CardContent>
            <Dialog
                open={open}
                onClose={dialogActions.off}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Delete Place</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to Delete this place!
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={dialogActions.off} color="inherit">
                        Cancel
                    </Button>

                    <Button
                        onClick={onDelete}
                        color="error"
                        variant="contained"
                        loading={mutateDeletePlace.isPending}
                        autoFocus
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Card>
    );
};
